import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'

const InteractorReturnHeaderApproval = () => {
  const { t } = useTranslation()
  const returnHeaderApproval = useCallback(
    (payload) => {
      delete payload.transaction_uid
      ApiService.jsonRequest('/transaction-retur-header/approval', payload, (response) => {
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message:
              payload.status === 'APPROVED'
                ? t('response_message.return_approve_success')
                : t('response_message.return_reject_success'),
            timer: 2000,
            redirect: `/return`,
          })
        } else {
          showAlert({
            icon: 'warning',
            message:
              payload.status === 'APPROVED'
                ? t('response_message.return_approve_failed')
                : t('response_message.return_reject_failed'),
            timer: 2000,
            redirect: `/return`,
          })
        }
      })
    },
    [t],
  )
  return { returnHeaderApproval }
}

export default InteractorReturnHeaderApproval
